export default __webpack_public_path__ + "static/media/green-ball.c84d5fd5.svg";